import { buttonClasses, ButtonProps } from '@mui/material/Button';
import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function LoadingButton(theme: Theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ButtonProps }) => ({
          ...(ownerState.variant === 'soft' && {
            [`& .${buttonClasses.loadingPositionStart}`]: {
              left: 10,
            },
            [`& .${buttonClasses.loadingPositionEnd}`]: {
              right: 14,
            },
            ...(ownerState.size === 'small' && {
              [`& .${buttonClasses.loadingPositionStart}`]: {
                left: 10,
              },
              [`& .${buttonClasses.loadingPositionEnd}`]: {
                right: 10,
              },
            }),
          }),
        }),
      },
    },
  };
}
